module.exports = __webpack_public_path__ + "img/img0.2c5efa8b.jpg";